module.exports = __webpack_public_path__ + "static/istanbul-2026-09c8a3969d98ffc4b4d11f51044e8881.jpg";